import { ACTIVITIES_CHANNEL } from '@app/constants/channels'
import { closeChannel, openChannel } from '@app/actions/activities/activitiesChannel'
import openCable from '../cable'

const activitiesChannel = ({ request, response }) => {
  const cable = openCable()
  let subscription = cable.subscriptions.consumer.subscriptions.subscriptions.find((sub) => sub.identifier.includes('ActivitiesChannel'))
  if (!subscription) {
    subscription = cable.subscriptions.create(ACTIVITIES_CHANNEL, {
      connected() {
        request(this)
        store.dispatch(openChannel())
      },
      received(data) {
        response(data)
      },
      disconnected: () => {
        store.dispatch(closeChannel())
      },
    })
  }
  return subscription
}

export default activitiesChannel
